import { Component, contentChild, effect, HostBinding, input, ChangeDetectionStrategy } from '@angular/core'
import { MatCard } from '@angular/material/card'

/**
 * Expects a <mat-card> ... </mat-card>
 */
@Component({
  selector: 'lib-outlined-card',
  template: '<ng-content></ng-content>',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @use '@angular/material' as mat;

    :host {
      --width: 0;
      display: block;
      @include mat.card-overrides(
        (
          outlined-outline-width: var(--width),
        )
      );
    }
  `,
})
export class OutlinedCardComponent {
  readonly card = contentChild.required(MatCard)

  readonly outlineWidth = input('0')

  @HostBinding('style.--width')
  get styles() {
    return this.outlineWidth()
  }

  private readonly applyStyle = effect(() => {
    this.card().appearance = 'outlined'
  })
}
